var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pb-10" },
    [
      _c("TabsWithRoutes", {
        staticClass: "mb-0.5",
        attrs: {
          routeTabs: _vm.routeTabs,
          navClass: "navParent",
          variant: "black",
        },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.routes.ALL_EMPTY_VISITS_TAB,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1" }, [
                    _vm._v("All open visits"),
                  ]),
                  _c("TabNotificationBubble", {
                    attrs: {
                      notification: _vm.allEmptyTotal,
                      gray: "",
                      medium: true,
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: _vm.routes.PENDING_VISITS,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1" }, [_vm._v("Offered")]),
                  _c("TabNotificationBubble", {
                    attrs: {
                      notification: _vm.offeredTotal,
                      gray: "",
                      medium: true,
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: _vm.routes.REJECTED_VISITS,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1" }, [_vm._v("Declined")]),
                  _c("TabNotificationBubble", {
                    attrs: {
                      notification: _vm.declinedTotal,
                      gray: "",
                      medium: true,
                    },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: _vm.routes.ALL_DRAFT_VISITS,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1" }, [_vm._v("Draft")]),
                  _c("TabNotificationBubble", {
                    attrs: {
                      notification: _vm.draftTotal,
                      gray: "",
                      medium: true,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm.dialog
        ? _c("ProjectModal", {
            attrs: { companyId: _vm.company.id, currentUser: _vm.currentUser },
            on: {
              close: function ($event) {
                _vm.dialog = false
              },
            },
          })
        : _vm._e(),
      _c("router-view", {
        attrs: {
          company: _vm.company,
          currentUser: _vm.currentUser,
          totalVisits: _vm.allEmptyTotal,
          offeredVisits: _vm.offeredTotal,
          declinedTotal: _vm.declinedTotal,
          draftTotal: _vm.draftTotal,
          assignedTotal: _vm.assignedTotal,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }